module.exports = __webpack_public_path__ + "img/5轮播图-750x400.91f3d5fa.jpg";